import React, { lazy, Suspense } from 'react'
import LoadingComponent from 'components/generic/LoadingComponent'

const LazyComponent = lazy(() => import(/* webpackChunkName: "image-gallery" */ './'))

export default function AssetsGalleryLazy(props) {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
